import { render, staticRenderFns } from "./DnDissertation.vue?vue&type=template&id=c74a1bdc&scoped=true&"
import script from "./DnDissertation.vue?vue&type=script&lang=js&"
export * from "./DnDissertation.vue?vue&type=script&lang=js&"
import style0 from "./DnDissertation.vue?vue&type=style&index=0&id=c74a1bdc&lang=scss&scoped=true&"
import style1 from "./DnDissertation.vue?vue&type=style&index=1&id=c74a1bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74a1bdc",
  null
  
)

export default component.exports